import EightByEightLogo from '@/assets/images/8x8-tcap.svg';

const EightByEightIcon = ({ size = 25 }) => (
    <img
        src={EightByEightLogo}
        alt="8x8 Logo"
        style={{ height: size, width: size }}
    />
);

export default EightByEightIcon;
